<template>
  <div>
    <!-- 批量发送 -->
    <el-dialog title="批量发送短信"
               width="1000px"
               center
               custom-class="batchSend-dialog"
               :visible.sync="batchSendDia"
               :before-close="close">
      <div class="content">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="100px"
                 class="demo-ruleForm">

          <el-form-item label="接收人"
                        prop="user_type">
            <el-radio-group v-model="ruleForm.user_type">
              <el-radio :label="1">医生</el-radio>
              <el-radio :label="3">业务</el-radio>
              <el-radio :label="2">患者</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="短信内容"
                        prop="content"
                        class="content-item">
            <el-input type="textarea"
                      v-model="ruleForm.content"
                      :rows="6"
                      placeholder="请输入短信内容"
                      maxlength="500"
                      show-word-limit></el-input>
            <div style="line-height: 20px;">
              引用医生姓名请使用${doctor_name}、引用患者姓名请使用${user_name}、引用开方日期请使用${pre_time}、引用问诊发起日期请使用${con_time}
            </div>
            <div class="import-btn">
              <el-button type="primary"
                         size="small"
                         @click="is_show = true">导入模板内容</el-button>
            </div>
          </el-form-item>
          <el-form-item v-if="is_show"
                        label="模板标题"
                        prop="sms_title">
            <el-select v-model="selectContent"
                       filterable
                       remote
                       reserve-keyword
                       placeholder="请输入短信模板标题"
                       :remote-method="getSmsTemplate"
                       @change="changeSelect"
                       :loading="loading">
              <el-option v-for="item in options"
                         :key="item.tcm_id"
                         :label="item.sms_title"
                         :value="item.sms_content">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item style="text-align: center;padding-right:100px">
            <el-button size="small"
                       @click="close">取 消</el-button>
            <el-button size="small"
                       type="primary"
                       @click="submitForm('ruleForm')">确 定</el-button>
          </el-form-item>

        </el-form>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import common from '@/api/common.js';
export default {
  props: {
    batchSendDia: {
      type: Boolean,
      require: true
    },
    ids: {
      type: Array,
      require: true
    },
    interfaceName: {
      type: String,
      require: true
    },
    user_type: {
      type: [String, Number],
      require: true
    }
  },

  data() {
    return {
      is_show: false,
      ruleForm: {
        user_type: '',
        content: ''
      },
      rules: {
        user_type: [{ required: true, message: '请选择', trigger: 'change' }],
        content: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      selectContent: '',
      options: [],
      loading: false
    };
  },
  watch: {
    batchSendDia: {
      handler: function (n) {
        if (n) {
          this.$refs['ruleForm'] ? this.$refs['ruleForm'].resetFields() : '';
          this.selectContent = '';
          this.ruleForm.user_type = this.user_type;
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {},
  methods: {
    getSmsTemplate(query) {
      if (query != '') {
        this.loading = true;
        common
          .getSmsTemplate({ sms_title: query })
          .then((res) => {
            let { code, data } = res;
            if (code === 0) {
              this.options = data.list;
            }
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
          });
      } else {
        this.options = [];
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.ruleForm);
          this.interfaceName == 'batchSendConsultSms'
            ? (params['consult_id'] = this.ids)
            : (params['pre_id'] = this.ids);
          common[this.interfaceName](params).then((res) => {
            let { code, data } = res;
            if (code === 0) {
              if (data.code == -1) {
                let content = '';
                for (let item of data.msg) {
                  content += `<div style="word-wrap:break-word">${item}</div>`;
                }
                this.$confirm(content, '提示', {
                  confirmButtonText: '知道了',
                  dangerouslyUseHTMLString: true,
                  showCancelButton: false,
                  center: true,
                  type: 'warning'
                })
                  .then(() => {
                    this.close();
                    this.$emit('refreshList');
                  })
                  .catch(() => {});
              } else {
                this.$message.success('发送成功');
                this.close();
                this.$emit('refreshList');
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    close(data) {
      this.$emit('update:batchSendDia', false);
    },
    changeSelect(val) {
      this.ruleForm.content = val;
    }
  }
};
</script>

<style lang="scss" >
.batchSend-dialog {
  .content {
    padding: 10px 20px;
    .demo-ruleForm {
      .content-item {
        position: relative;
        .el-form-item__content {
          height: 180px;
        }
        .import-btn {
          position: absolute;
          bottom: 46px;
          right: 10px;
        }
      }
    }
  }
}
</style>